module.exports = __webpack_public_path__ + "static/media/wall6.1b1e4276.jpeg";